// extracted by mini-css-extract-plugin
export default {"root":"UWFVzpRB_gZNUZctpIml"};